export const CREATE_EINVOICE_CREDENTIAL = 'CREATE_EINVOICE_CREDENTIAL';
export const CREATE_EINVOICE_CREDENTIAL_SUCCESS = 'CREATE_EINVOICE_CREDENTIAL_SUCCESS';
export const CREATE_EINVOICE_CREDENTIAL_FAILED = 'CREATE_EINVOICE_CREDENTIAL_FAILED';

export const GET_EINVOICE_CREDENTIAL = 'GET_EINVOICE_CREDENTIAL';
export const GET_EINVOICE_CREDENTIAL_SUCCESS = 'GET_EINVOICE_CREDENTIAL_SUCCESS';
export const GET_EINVOICE_CREDENTIAL_FAILED = 'GET_EINVOICE_CREDENTIAL_FAILED';

export const UPDATE_EINVOICE_CREDENTIAL = 'UPDATE_EINVOICE_CREDENTIAL';
export const UPDATE_EINVOICE_CREDENTIAL_SUCCESS = 'UPDATE_EINVOICE_CREDENTIAL_SUCCESS';
export const UPDATE_EINVOICE_CREDENTIAL_FAILED = 'UPDATE_EINVOICE_CREDENTIAL_FAILED';

export const DELETE_EINVOICE_CREDENTIAL = 'DELETE_EINVOICE_CREDENTIAL';
export const DELETE_EINVOICE_CREDENTIAL_SUCCESS = 'DELETE_EINVOICE_CREDENTIAL_SUCCESS';
export const DELETE_EINVOICE_CREDENTIAL_FAILED = 'DELETE_EINVOICE_CREDENTIAL_FAILED';